import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  // Inline callouts inside a resource's Variables card: an error banner listing
  // referenced-but-undeclared $var names (each with a Declare action) and a
  // warning banner for bare {{...}} tokens (each with a Convert action).
  callout: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
    paddingTop: tokens.spacingVerticalS,
    paddingRight: tokens.spacingHorizontalM,
    paddingBottom: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalM,
    borderRadius: tokens.borderRadiusMedium,
    borderLeftWidth: tokens.strokeWidthThick,
    borderLeftStyle: 'solid',
    marginBottom: tokens.spacingVerticalS,
  },
  calloutError: {
    backgroundColor: tokens.colorPaletteRedBackground1,
    borderLeftColor: tokens.colorPaletteRedBorder2,
  },
  calloutWarning: {
    backgroundColor: tokens.colorPaletteYellowBackground1,
    borderLeftColor: tokens.colorPaletteYellowBorder2,
  },
  calloutTitle: {
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
  },
  calloutText: {
    color: tokens.colorNeutralForeground2,
    fontSize: tokens.fontSizeBase200,
  },
  calloutList: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
    marginTop: tokens.spacingVerticalXS,
  },
  calloutRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: tokens.spacingHorizontalM,
  },
  calloutCode: {
    fontFamily: tokens.fontFamilyMonospace,
    backgroundColor: tokens.colorNeutralBackground3,
    paddingTop: tokens.spacingVerticalXXS,
    paddingRight: tokens.spacingHorizontalXS,
    paddingBottom: tokens.spacingVerticalXXS,
    paddingLeft: tokens.spacingHorizontalXS,
    borderRadius: tokens.borderRadiusSmall,
  },
});
